import React from 'react';
import * as PropTypes from 'prop-types';
import { safeHTML } from '../../../../utils/safeHTML';
import Icon from '../icon/Icon';
import classNames from 'classnames';
import { useTranslation } from '../../../../translations';
import { CustomButton } from '../../../features/customButton';

export default function CustomMenuButton({ text, icon, iconD, className, attr }) {
  const { t } = useTranslation();

  return (
    <CustomButton
      className={classNames('custom-menu__button', {
        [className]: className,
      })}
      {...attr}
    >
      {text && <span className='custom-menu__button-text'> {safeHTML(t(text))} </span>}
      {(icon || iconD) && (
        <>
          <span className='custom-menu__button-icon _desktop'>
            <Icon name={iconD} />
          </span>
          <span className='custom-menu__button-icon _mobile'>
            <Icon name={icon} />
          </span>
        </>
      )}
    </CustomButton>
  );
}

CustomMenuButton.propTypes = {
  className: PropTypes.string,
  attr: PropTypes.object,
  text: PropTypes.string,
};
